import { Box, Card, Grid, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import ProfileCard from "../../components/employeeProfileCards/profileCard";
import BreakHistoryChart from "../../components/charts/breakHistory";
import useWorkerStore from "../../zustand/useWorkerStore";
import CustomSelect from "../../components/customSelect";
import { User } from "lucide-react";
import { MenuItem } from "@mui/material";
import { Calendar } from "lucide-react";
import { getEmployeeAnalytics } from "../../services/activity";
import { openSnackAlert } from "../../helper";
import AppLoader from "../../components/appLoader";
// import ActivityChart from "../../components/employeeProfileCards/activityChart";

const EmployeeAnalytic = () => {
  const [selectedWorker, setSelectedWorker] = useState(null);
  const [employeeAnalytics, setEmployeeAnalytics] = useState(null);
  const [loading, setLoading] = useState(false);
  const { allWorkers } = useWorkerStore();

  // Get selected worker details
  const selectedWorkerDetails = selectedWorker
    ? allWorkers.find((worker) => worker._id === selectedWorker)
    : null;

  const handleWorkerChange = (event) => {
    const workerId = event.target.value;
    setSelectedWorker(workerId);
  };

  const handleFetchEmployeeAnalytics = async () => {
    try {
      setLoading(true);
      const response = await getEmployeeAnalytics(selectedWorker);
      console.log(response, "response");
      if (response?.status === 200 || response?.status === 201) {
        setEmployeeAnalytics(response.data.data);
      } else {
        openSnackAlert(
          response?.message || "Get employee analytics failed",
          "error"
        );
      }
    } catch (error) {
      console.log(error, "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedWorker) {
      handleFetchEmployeeAnalytics();
    } else {
      // Clear analytics data when no worker is selected
      setEmployeeAnalytics(null);
    }
  }, [selectedWorker]);

  return (
    <Box
      bgcolor="primary.bgLight"
      padding={"20px"}
      borderRadius={"22px"}
      mt={0}
    >
      <Grid container spacing={2}>
        <Grid item sm={12} md={5}>
          <Typography variant="h4">Employee Analytics</Typography>
          <Typography variant="description">
            Track employee analytics
          </Typography>
        </Grid>
        <Grid item sm={12} spacing={2} md={7}>
          <Box
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-end",
            }}
          >
            <CustomSelect
              name="worker"
              placeholder="Select Worker"
              value={selectedWorker}
              onChange={handleWorkerChange}
              endIcon={<User size={16} />}
              sx={{ width: "100%", height: "36px" }}
              InputWidth="40%"
            >
              {allWorkers.map((worker) => (
                <MenuItem key={worker._id} value={worker._id}>
                  {worker.firstName} {worker.lastName}
                </MenuItem>
              ))}
            </CustomSelect>
          </Box>
        </Grid>
      </Grid>
      {!selectedWorker ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "400px",
            textAlign: "center",
          }}
        >
          <Calendar size={64} color="#9E9E9E" />
          <Typography variant="h5" sx={{ mt: 2, color: "text.secondary" }}>
            Please Select Worker
          </Typography>
          <Typography variant="body1" sx={{ mt: 1, color: "text.secondary" }}>
            Choose a worker from the dropdown above to view their analytics data
          </Typography>
        </Box>
      ) : (
        <>
          <AppLoader isVisible={loading} />
          <Grid container spacing={3}>
            <Grid item xs={12} md={3}>
              {selectedWorkerDetails && (
                <ProfileCard
                  employee={{
                    name: `${selectedWorkerDetails.firstName} ${selectedWorkerDetails.lastName}`,
                    designation:
                      selectedWorkerDetails.designation || "Employee",
                    id:
                      selectedWorkerDetails.employeeId ||
                      selectedWorkerDetails._id,
                    phone:
                      selectedWorkerDetails.contact ||
                      selectedWorkerDetails.phone,
                    email: selectedWorkerDetails.email,
                    photo:
                      selectedWorkerDetails.profileImage ||
                      "https://randomuser.me/api/portraits/men/32.jpg",
               
                  }}
                />
              )}
            </Grid>
            <Grid item xs={12} md={9}>
                <Box mt={2}>
                  <Card
                    sx={{
                      border: "2px solid #2E7D32",
                      borderRadius: "18px",
                      p: 2,
                      bgcolor: "#fff",
                      boxShadow: 0,
                    }}
                  >
                    <BreakHistoryChart
                      chartData={employeeAnalytics?.chartData || []}
                    />
                  </Card>
                </Box>
            </Grid>
          </Grid>
        </>
      )}
    </Box>
  );
};

export default EmployeeAnalytic;
